import { Component, OnInit, ViewChild } from '@angular/core';
import { SidebarService } from '../sidebar/sidebar.service';
import { TopbarService } from './topbar.service';
import { LocalStorageService } from 'angular-web-storage';
import { LoginService } from 'src/app/modules/login/login.service';
import { NotificationsService } from 'src/app/modules/notifications/_services/notifications.service';
import { AndFilter, Filter, FilterOperation, NotFilter, OrFilter } from '../jsonapi/filter';
import { IParamsCollection } from '../jsonapi/interfaces/params-collection';
import { FilterBuilder } from '../jsonapi/filters-builder';
import { PhoneService } from 'src/app/modules/phone/_services/phone.service';
import { Router } from '@angular/router';
import { User } from 'src/app/modules/users/_types/user';
import { UsersService } from 'src/app/modules/users/_services/users.service';
import { firstValueFrom } from 'rxjs';
import { StringUtilsService } from '../services/string-utils.service';
import { MessageService } from 'primeng/api';
import { CasesService } from 'src/app/modules/cases/_services/cases.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { CasesServicesService } from 'src/app/modules/cases/_services/cases-services.service';
import moment from 'moment';
import { ChatRoomUsersService } from 'src/app/modules/chat/_services/chat-room-users.service';
import { ChatRoomMessagesService } from 'src/app/modules/chat/_services/chat-room-messages.service';
import { WhatsappMessageService } from 'src/app/modules/comunications/_services/whatsapp-messages.service';
import { ChatService } from 'src/app/modules/chat/_services/chat.service';
import { ChatRoomsService } from 'src/app/modules/chat/_services/chat-rooms.service';
import { ContractProcessorsService } from 'src/app/modules/companies/_services/contracts-processors.service';
import { Case } from 'src/app/modules/cases/_types/case';
import { DialogService } from 'primeng/dynamicdialog';
import { CasesDetailGeneralComponent } from 'src/app/modules/cases/cases-detail/general/general.component';
import { DashboardService } from 'src/app/modules/home/_services/dashboard.service';

@Component({
    selector: 'app-topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.scss'],
    standalone: false
})
export class TopbarComponent implements OnInit {

  @ViewChild('notificationSidebar') private notificationSidebar!: any;  

  public user: any = {};
  public changeUser?: User;
  public notificationsCount: number = 0;
  public userActions: any ;
  public visibleChangePass: boolean = false;
  public password: string = "";
  public searchTerm: string = '';
  public filterText: string = '';
  public results: any[] = [];
  public filteredResults: any[] = [];
  public originalFilterResults: any[] = [];

  private intervalPhoneStatus: any;
  public isPhoneConnected: boolean = false;
  public servicesOffTime: number = 0;
  public chatsNotReaded: number = 0;
  public title: string = 'GUAI';
  public actions: any[] = [];
  public count: number | null = null;
  public subtitle: string = '';
  public breadcrumb: any[] = [];
  public usersSameContractsIds: any[] = [];
  public orderBy = 'caseDate';
  public totalResults = 0;

  @ViewChild('overlay') overlay!: OverlayPanel;  
 public filters: any = {
            readedAt: new Filter(FilterOperation.equals, 'readedAt', '', null, true),
            web: new Filter(FilterOperation.equals, 'web', '', true),
            userId: new Filter(FilterOperation.any, 'userId', ''),            
            source: new NotFilter(FilterOperation.equals, 'source', '', 'Chat')
        };

  public totalcasesIsInitial: number= 0;
  
    public totalLogsRecords: number = 0;
    public totalServicesEnded: number = 0;

  private updateUserActions() {
    this.userActions = [
      {
        label: 'Cambiar contraseña',
        icon: 'pi pi-pencil',
        command: () => this.changePassword() 
      },
      /*{
        label: (this.storage.get("darkMode") ? 'Modo claro' : 'Modo oscuro'),
        icon: (this.storage.get("darkMode") ? 'pi pi-sun' : 'pi pi-moon'),
        command: () => this.toggleDarkMode() 
      },*/
      {
        label: 'Cerrar sesión',
        icon: 'pi pi-sign-out',
        command: () => this.logout()
      }
    ];
  }

  constructor(
    public topbarService: TopbarService,
    public sidebarService: SidebarService,
    private storage: LocalStorageService,
    private loginService: LoginService,
    private notificationService: NotificationsService,
    private phoneService: PhoneService,
    private router: Router,
    private userService: UsersService,
    private stringUtils: StringUtilsService,
    private messageService: MessageService,
    private casesService: CasesService,
    private casesServiceService: CasesServicesService,
    private chatRoomsService: ChatRoomsService,
    private chatRoomMessageService: ChatRoomMessagesService,
    private chatService: ChatService,
    private contractProcessorsService: ContractProcessorsService,
    private dialogService: DialogService,
    private dashboardService: DashboardService,
    private whatsappMessageService: WhatsappMessageService
  ) {


    this.loginService.onLogin.subscribe((logged) => {
      if(logged) this.loadUserData();
    });

    this.updateUserActions();

    setInterval(() => {
      this.title = this.topbarService.getTitle();
      this.actions = this.topbarService.getActions();
      this.count = this.topbarService.getCount();
      this.subtitle = this.topbarService.getSubtitle();
      this.breadcrumb = this.topbarService.getBreadcrumb().filter((item: any) => !!item.label);
    }, 1000);

  }

  isPrimaryAction(action: any): boolean {
    return /\bpi-plus\b/.test(action.icon ?? '');
  }

  async ngOnInit() {

    this.loadUserData();
    await this.loadProcessorContracts();
    
    this.loadNotificationsCount();
    this.loadServicesOffTime();
    this.loadChatData(true);

    //escuchamos eventos de notificaciones de mi usuario
    this.notificationService.onNotificationReaded.subscribe(() => {
      this.loadNotificationsCount();
    });

    //comprobamos estado de telefono
    this.intervalPhoneStatus = setInterval(() => {
      this.isPhoneConnected = this.phoneService.isConnected;
    }, 2000);

    this.chatService.onCloseListChats.subscribe(() => {
      this.loadChatData(false);
    });

    this.loadTopbarInfo();
  }

  ngOnDestroy() {
    clearInterval(this.intervalPhoneStatus);
  }

  async loadProcessorContracts(){
      //Se busca la información del combo de la pantalla
      let filterP: any = {
        processorId: new Filter(FilterOperation.equals, 'processorId', '', this.user.id)
      };
      let paramsP:IParamsCollection = {
        filter: FilterBuilder.fromObject(filterP).build()
      };
      let responseP = await firstValueFrom(this.contractProcessorsService.all(paramsP));
      let processorContractIds = responseP.data.map(pc => pc.contractId);
  
      //los tramitadores de los mismos contratos que el usuario
      let filtersCases = {
        contractId: new Filter(FilterOperation.any, 'contractId', "", processorContractIds)        
      };  
      let paramsCases: IParamsCollection = { page: { number: 1, size: 2000}}
      //creamos filtros
      paramsCases.filter = FilterBuilder.fromObject(filtersCases).build();
      var contractProcessorsAll = await firstValueFrom(this.contractProcessorsService.all(paramsCases)).then(response => response.data);
      
      this.usersSameContractsIds = contractProcessorsAll.filter((v, i, a) => a.findIndex(t => (t.processorId === v.processorId)) === i).map(cp => cp.processorId);
    }
  

  loadUserData(){
    let user = this.storage.get("user");
    if(user) this.user = this.storage.get("user");
  }

  async loadNotificationsCount(){
    
    let intervalTimeout = 120;
    if(this.user!=null){
      if(!document.hidden){

        let cachedNotificationsCountMeta = this.storage.get("notificationsCountMeta");
        if(cachedNotificationsCountMeta==null){
          this.filters = {
            readedAt: new Filter(FilterOperation.equals, 'readedAt', '', null, true),
            web: new Filter(FilterOperation.equals, 'web', '', true),
            source: new NotFilter(FilterOperation.equals, 'source', '', 'Chat')
          };
          //para tener en cuenat los ausentes.
          if(this.usersSameContractsIds.length>0){
            this.filters["userId"] = new OrFilter([
                new Filter(FilterOperation.equals, 'userId', '', this.user.id),
                new AndFilter([
                    new Filter(FilterOperation.equals, 'user.absence', '', true),
                    new Filter(FilterOperation.any, 'userId', '', (this.usersSameContractsIds.length>0?this.usersSameContractsIds:this.user.id), true)
                ])
            ]);
          }else{
            this.filters["userId"] = new OrFilter([
                new Filter(FilterOperation.equals, 'userId', '', this.user.id)
            ]);
          }

          let params:IParamsCollection = {
              page: { size: 1 },
              filter: FilterBuilder.fromObject(this.filters).build()
          };
          this.notificationService.all(params, true).subscribe((response:any) => {
            if(response){
              this.notificationsCount = response.meta['total'];
              this.storage.set("notificationsCountMeta", response.meta, 2, 'm');
              //console.log("Notifications count loaded from API", this.notificationsCount);
            }
          },(error) => {
            console.error("Error loading notifications count", error);
          });
        }else{
          this.notificationsCount = cachedNotificationsCountMeta['total'];
          //console.log('Notifications count from local cache', this.notificationsCount);
        }
      }else{
        //console.log("Documento no visible, no se cargan las notificaciones");
        intervalTimeout = 5;
      }
      setTimeout(() => { this.loadNotificationsCount(); }, intervalTimeout * 1000);
    }else{
      setTimeout(() => { this.loadNotificationsCount(); }, intervalTimeout * 1000);
    }
  }

  async loadServicesOffTime() {
    let intervalTimeout = 120;
    if(!document.hidden){
      let cachedServicesOffTime = this.storage.get("servicesOffTime");
      if(cachedServicesOffTime==null){
        var response = await firstValueFrom(this.casesServiceService.getOffTimeCount());
        //console.log(response);
        this.servicesOffTime = response.total;
        this.storage.set("servicesOffTime", response, 2, 'm');
        console.log("Services off time loaded from API");
      }else{
        this.servicesOffTime = cachedServicesOffTime.total;
        console.log('Services off time from local cache');
      }
    }else{
      console.log("Documento no visible, no se cargan los servicios fuera de tiempo");
      intervalTimeout = 5;
    }
    setTimeout(() => { this.loadServicesOffTime(); }, intervalTimeout * 1000);
  }

  async search(search: string, full: boolean = false) {
      let response = await firstValueFrom(this.casesService.search(search, full));
      this.results = response.data;
      this.totalResults = response.meta['total'];
      console.log("Total results:", this.totalResults);
      this.filteredResults = response.data;   
      this.originalFilterResults = [...this.filteredResults]; 
      
      if (!this.overlay.overlayVisible) {
        this.overlay.show(event);
      }
  }

  async onSearch(event: Event) {
    const search = (event.target as HTMLInputElement).value.trim();
    if (search.length >= 1) {
      //this.search(search,false);
      let response = await firstValueFrom(this.casesService.search(search, false));
      this.results = response.data;
      this.totalResults = response.meta['total'];
      console.log("Total results:", this.totalResults);
      this.filteredResults = response.data;   
      this.originalFilterResults = [...this.filteredResults]; 
      
      if (!this.overlay.overlayVisible) {
        this.overlay.show(event);
      }
    }
  }

sortByRelevance<T>(items: T[], getValue: (item: T) => string, search: string): T[] {
  return [...items].sort((a, b) => {
    const aVal = getValue(a);
    const bVal = getValue(b);
   
    // 1. Coincidencia exacta
    const aExact = aVal === search;
    const bExact = bVal === search;
    if (aExact && !bExact) return -1;
    if (!aExact && bExact) return 1;

    // 2. Empieza con el término buscado
    const aStarts = aVal.startsWith(search);
    const bStarts = bVal.startsWith(search);
    if (aStarts && !bStarts) return -1;
    if (!aStarts && bStarts) return 1;

    // 3. Contiene el término buscado
    const aContains = aVal.includes(search);
    const bContains = bVal.includes(search);
    if (aContains && !bContains) return -1;
    if (!aContains && bContains) return 1;

    // 4. Cuanto más corto (menos "ruido" alrededor), mejor
    return aVal.length - bVal.length;
  });
}
  async orderByCases(orderBy: string){
    if(orderBy == "caseNumber"){
      if(this.totalResults <= 25){
        this.filteredResults = this.sortByRelevance(this.filteredResults, (item) => item.caseNumber, this.searchTerm);        
      }else{
        let response = await firstValueFrom(this.casesService.search(this.searchTerm, false, true));
        this.filteredResults = response.data;
        this.totalResults = response.meta['total'];
      }
      this.orderBy = "caseNumber";
    }else{

      if(this.totalResults <= 25){        
        this.filteredResults = [...this.originalFilterResults];        
      }else{
        let response = await firstValueFrom(this.casesService.search(this.searchTerm, false, false));
        this.filteredResults = response.data;
        this.totalResults = response.meta['total'];
      }
      this.orderBy = "caseDate";
    }
    
  }
  async deepSearch(){
    this.search(this.searchTerm,true);
  }

  async onSelectCase() {    
    await this.resetSearch()
    this.overlay.hide();
  }

  async onOverlayHide() {
    await this.resetSearch();
  }

  async resetSearch(){
    this.searchTerm = "";
    this.filterText = "";
    this.orderBy = 'caseDate';
    this.results = [];
  }

  filterResults() {
    const filter = this.filterText.toLowerCase().trim();
      this.filteredResults = this.results.filter(item => {
      
      const caseDateFormatted = item.caseDate
        ? (() => {
            const date = new Date(item.caseDate);
            const day = String(date.getDate()).padStart(2, '0');       
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return day+"/"+month+"/"+year;                          
          })()
        : '';
  
      return (
        item.reference?.toLowerCase().includes(filter) ||
        item.caseNumber?.toLowerCase().includes(filter) ||
        item.client?.name?.toLowerCase().includes(filter) ||
        item.caseState?.name?.toLowerCase().includes(filter) ||
        item.address?.fullAddress?.toLowerCase().includes(filter) ||
        item.description?.toLowerCase().includes(filter) ||
        caseDateFormatted.includes(filter)
      );
    });
  }

  showChats(){
    this.chatService.openChatList();
  }

  showNotifications(){
    this.notificationService.openNotifications();
  }

  showPhone(){
    this.phoneService.openPhone();
  }

  logout() {
    this.loginService.logout();
  }

  showProcessorHome(){
    this.router.navigate(['/homeProcessor']);
  }

  async changePassword(){
    this.changeUser = await firstValueFrom( this.userService.get(this.user.id));
    this.visibleChangePass = true;
  }

  saveChangePassword(changeUserPassword: string){
    if(changeUserPassword != null && changeUserPassword != ""){
      if(this.changeUser != null) {
        this.changeUser.password = this.stringUtils.ToMD5(changeUserPassword);
        this.userService.save(this.changeUser).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: true, severity: 'success', detail: "Constraseña modificada correctamente." });
            this.visibleChangePass = false;
            this.password = "";
          },
          error: (error: any) => {
            console.log(error);
          }
        });
      }
    }
  }

  async loadChatData(setTimeoutFn: boolean = false) {
    //si el documento esta visible
    let intervalTimeout = 60;
    if(!document.hidden){
      //comprobamos si hay en cache local
      let cachedChatsNotReaded = this.storage.get("chatsNotReaded");
      if(cachedChatsNotReaded==null){
        let user = this.storage.get("user");
        if(user!=null){
          let response:any = await firstValueFrom(this.chatRoomsService.GetUnread());

          //la insignia suma los chats internos y los whatsapp entrantes pendientes. El whatsapp va en
          //best-effort: si su endpoint falla, se sigue mostrando el contador de chats en vez de dejar
          //la campana a cero. Se pide solo el contador (/unread-count), no la lista completa.
          let whatsappUnreadCount = 0;
          try{
            whatsappUnreadCount = await firstValueFrom(this.whatsappMessageService.GetUnreadCount());
          }catch(error){
            console.error("Error loading unread whatsapp count", error);
          }

          this.chatsNotReaded = response.length + whatsappUnreadCount;
          this.storage.set("chatsNotReaded", { chats: response.length, whatsapp: whatsappUnreadCount }, 1, 'm');
          console.log("Chats not readed count loaded from API");
        }
      }else{
        //la cache guardaba un array y ahora guarda los dos contadores. Se contempla el formato viejo
        //porque puede quedar en el localStorage de quien tenga la aplicacion abierta al desplegar.
        if(Array.isArray(cachedChatsNotReaded)){
          this.chatsNotReaded = cachedChatsNotReaded.length;
        }else if(cachedChatsNotReaded && typeof cachedChatsNotReaded === 'object'){
          this.chatsNotReaded = (cachedChatsNotReaded.chats ?? 0) + (cachedChatsNotReaded.whatsapp ?? 0);
        }else{
          this.chatsNotReaded = 0;
        }
        console.log("Chats not readed count from local cache");
      }
    }else{
      console.log("Documento no visible, no se cargan los chats");
      intervalTimeout = 5;
    }
      
    if(setTimeoutFn) setTimeout(() => { this.loadChatData(true); }, intervalTimeout * 1000);
  }

  createCase(caseItem: Case = {} as Case) {
    if (Object.keys(caseItem).length > 0) {
      this.router.navigate(['cases/' + caseItem.id]);
    } else {
      let ref = this.dialogService.open(CasesDetailGeneralComponent, {
        closable: true,
        modal: true,
        header: 'Datos generales',
        width: '50%',
        data: { }
      });
      ref.onClose.subscribe((data: Case) => {
        if (data != null) {
          this.router.navigate(['cases/' + data.id]);
        }
      });
    }

  }


   async loadTopbarInfo() {

    let intervalTimeout = 180; //cada 3 minutos...
    if(!document.hidden){
       let cachedTopbarInfo = this.storage.get("cachedTopbarInfo");
      if(cachedTopbarInfo==null){
        var response = await firstValueFrom(this.dashboardService.getInfoToolbar(this.user.id));    
        this.totalcasesIsInitial = response.totalcasesIsInitial;
        this.totalLogsRecords = response.totalLogsRecords;
        this.totalServicesEnded = response.totalServicesEnded;
        this.storage.set("cachedTopbarInfo", response, 3, 'm');
      }else{
        this.totalcasesIsInitial = cachedTopbarInfo['totalcasesIsInitial'];
        this.totalLogsRecords = cachedTopbarInfo['totalLogsRecords'];
        this.totalServicesEnded = cachedTopbarInfo['totalServicesEnded'];
      }
    }else{
      console.log("*** No se cargan los del topbarInfo");
      intervalTimeout = 5;
    }
    setTimeout(() => { this.loadTopbarInfo(); }, intervalTimeout * 1000);
  }
  
  goHome(link : string = ""){
    this.router.navigate(['/home' + link]);
  }

  toggleDarkMode(){
    this.storage.set("darkMode", !this.storage.get("darkMode"));
    if(this.storage.get("darkMode")){
      document.body.classList.add('dark-mode');
    }else{
      document.body.classList.remove('dark-mode');
    }

    this.updateUserActions();
  }

  get isDarkMode(): boolean {
    return !!this.storage.get("darkMode");
  }

  get userInitials(): string {
    const words = (this.user?.name ?? '').trim().split(/\s+/).filter((word: string) => word.length > 0);
    return words.slice(0, 2).map((word: string) => word[0].toUpperCase()).join('');
  }
}
